/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Nav_DocsInputs */

const en_marketing_nav_docs = /** @type {(inputs: Marketing_Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs`)
};

const es_marketing_nav_docs = /** @type {(inputs: Marketing_Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentación`)
};

const fr_marketing_nav_docs = /** @type {(inputs: Marketing_Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation`)
};

/**
* | output |
* | --- |
* | "Docs" |
*
* @param {Marketing_Nav_DocsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_nav_docs = /** @type {((inputs?: Marketing_Nav_DocsInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Nav_DocsInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_nav_docs(inputs)
	if (locale === "es") return es_marketing_nav_docs(inputs)
	return fr_marketing_nav_docs(inputs)
});